import PropTypes from 'prop-types';
import React from 'react';
import { inject } from 'mobx-react';

/*
  Component that aims to help mobile app know when a route has been
  rendered
 */

const LoadedRoute = inject('router')(({ router }) => {
  const loaderId = `loaded-route-${router.route.name}`;
  return (
    <div
      style={{
        display: 'none',
      }}
      id={loaderId}
    />
  );
});

LoadedRoute.propTypes = {
  router: PropTypes.object,
};

export default LoadedRoute;
